import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { Menu, PlusSquare } from 'lucide-react';
// Temporarily use a regular button instead of the Shadcn UI button
// import { Button } from './ui/button';
import LoginButtonComponent from './LoginButtonComponent';
import ProfileButton from './ProfileButtonComponent';

interface TopNavigationProps {
  sideNavToggle: () => void;
  newIssue: () => void;
}

const TopNavigation: React.FC<TopNavigationProps> = ({ sideNavToggle, newIssue }) => {
  const { isAuthenticated, isLoading } = useAuth0();

  return (
    <header className="fixed top-0 left-0 right-0 h-16 bg-white border-b border-gray-200 shadow-sm z-50">
      <div className="h-full px-4 flex items-center justify-between">
        {/* Left section: Menu toggle and logo */}
        <div className="flex items-center gap-4">
          <button
            onClick={sideNavToggle}
            className="p-2 rounded-md hover:bg-gray-100"
            aria-label="Toggle menu"
          >
            <Menu className="h-5 w-5" />
          </button>
          
          <Link to="/" className="flex items-center gap-2">
            <img src="/Fxer.AI (7).png" alt="Fxer fox logo" className="h-8 w-auto" />
            <span className="font-bold text-xl text-fxer-blue">Fxer.AI</span>
          </Link>
        </div>
        
        {/* Right section: Actions */}
        <div className="flex items-center gap-2">
          {!isLoading && (
            !isAuthenticated ? (
              <LoginButtonComponent />
            ) : (
              <>
                <button 
                  onClick={newIssue}
                  className="hidden md:flex items-center gap-1 px-3 py-2 bg-fxer-blue text-white text-sm rounded-md hover:opacity-90"
                >
                  <PlusSquare className="h-4 w-4" />
                  <span>New Property</span>
                </button>
                
                <button 
                  onClick={newIssue}
                  className="md:hidden p-2 rounded-md hover:bg-gray-100"
                  aria-label="New property"
                >
                  <PlusSquare className="h-5 w-5" />
                </button>
                
                <ProfileButton />
              </>
            )
          )}
        </div>
      </div>
    </header>
  );
};

export default TopNavigation;
